import type { $Fetch } from 'nitropack';

import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const getProducts = async (body: unknown) => $fetch<BFFResponse<unknown>>('/products', { method: 'POST', body });

  const getProductById = async (idOrKey: string, body: unknown) => $fetch<BFFResponse<{ statusCode: number; redirectUrl: string } | unknown>>(`/products/${idOrKey}`, { method: 'POST', body });

  const getCategoryFacets = async (body: unknown) => $fetch<BFFResponse<unknown>>('/products/category/facets', { method: 'POST', body });

  const getStockAndPrice = async (body: unknown) => $fetch<BFFResponse<unknown>>('/products/stockAndPrice', { method: 'POST', body: body });

  const getStockInStore = async (storeId: string, skus: string[]) => $fetch<BFFResponse<{ sku: string; stock: number }[]>>('/products/stockInStore', { query: { storeId, skus } });

  const getRelatedProducts = async (products: string[]) => $fetch<BFFResponse<unknown[]>>('/products/related', { query: { products } });

  const getProductsReduced = async (products: string[]) => $fetch<BFFResponse<unknown[]>>('/products/reduced', { query: { products } });

  return {
    getProducts,
    getProductById,
    getCategoryFacets,
    getStockAndPrice,
    getRelatedProducts,
    getProductsReduced,
    getStockInStore,
  };
};
